export default "__VITE_ASSET__Bl7m7A5T__"